/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelZoneRegion.ts                    *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/general/zone-region";

export class AutogenModelZoneRegion<RowType extends ModelRow> extends Endpoint<RowType, RowZoneRegionFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowZoneRegion extends ModelRow<RowZoneRegionFields> {
	constructor(values?: Partial<RowZoneRegionFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowZoneRegionFields {
	company_id: string;
	descr: string;
	id: string;
	zonesuperregion_id: string;
}

